// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.tags[data-v-2f655730] {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 5px;\n}\n.tags li[data-v-2f655730] {\n  transition: all 150ms linear;\n  height: 0;\n  overflow: hidden;\n}\n.tags li[data-v-2f655730]:not(:empty) {\n  height: 22px;\n}\n.tags li[data-v-2f655730]:not(:empty):nth-child(1) {\n  margin-top: 0.7rem;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
